module.exports = __webpack_public_path__ + "img/ckccc.27e71ae7.jpg";